import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/billing-models.js';
import q from '../query.js';
export const billingModelsEntity = `billing-models`;
export const billingModelsKey = `billing-models`;
export const useBillingModels = () => q.query(billingModelsKey, api.get, keys.read.collection(billingModelsEntity));
//# sourceMappingURL=index.js.map